import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/itemProcesso'

class ItemProcessoApiClient {
	async buscarListagem(filtro, paginacao) {
		const isNumeroValido = /^[0-9]+$/.test(filtro.processo)

		const filtrosConvertidos = {
			...filtro,
			numeroProcesso: isNumeroValido ? parseInt(filtro.processo, 10) : null,
			anoProcesso: parseInt(filtro.ano, 10),
			idOrgaoProcesso: filtro.orgao,
		}
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: isNumeroValido ? filtrosConvertidos : filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}

	async buscarItemProcessoPorFornecedor(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/porFornecedor`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}

	async buscarEditaisPorFiltro(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/buscarEditalProcesso`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}
}

export default new ItemProcessoApiClient()
